import classnames from 'classnames/bind';
import Input from 'components/Input';
import Typography from 'components/Typography';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useState } from 'react';
import styles from './CreateStudents.module.scss';

const cx = classnames.bind(styles);

const CreateStudents = ({ masterPassword }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const min = 1;
  const max = 1000;

  const [value, setValue] = useState(1);

  const handleChange = event => {
    const value = Math.max(min, Math.min(max, Number(event.target.value)));
    setValue(value);
  };

  return (
    <>
      <Typography type="h4">Teacher Creates Student Accounts</Typography>

      <Typography className={cx('description', 'mgt-15', 'mgb-25')}>
        Enter the number of accounts you want to create and a single password for all your students to use.
      </Typography>

      <Input
        value={value}
        onChange={handleChange}
        label="Number of accounts"
        name="students_number"
        inputRef={register('students_number', { required: true })}
        errors={errors}
        type="number"
        className={styles.numberInput}
        min={0}
      />

      <Input
        label="Password"
        name="password"
        inputRef={register('password', { required: true })}
        errors={errors}
        helperText="All students will use the same password"
        disabled={!!masterPassword}
      />
    </>
  );
};

export default CreateStudents;
